import { useEffect, useRef, useState } from 'react'
import { useFormik } from 'formik'
import domain from '../../../reusecomponent/domain.jsx';
import { getToken } from '../../function/token';
import Preloader from '../preloader';
import * as Yup from 'yup';
import { ErrorToastContainer, SuccessToastContainer } from '../../function/CustomFunction';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserEdit, faMapMarkerAlt,faFile } from '@fortawesome/free-solid-svg-icons';
import { useSelector } from 'react-redux';

function Myaccount() {
    const [loder,setloder] = useState(false);
    const [editingSection, setEditingSection] = useState(null); // 'personal' | 'address' | null
    const [editValues, setEditValues] = useState({});
    const [dataLoaded, setDataLoaded] = useState(false);
    const userServices = useSelector((state)=> state.serviceStore.value);

    // Function to get country name from country code
    const getCountryName = (countryCode) => {
        const countryMap = {
            'AR': 'Argentina',
            'BR': 'Brazil',
            'CL': 'Chile',
            'CO': 'Colombia',
            'EG': 'Egypt',
            'FR': 'France',
            'DE': 'Germany',
            'IN': 'India',
            'ID': 'Indonesia',
            'IL': 'Israel',
            'IT': 'Italy',
            'MY': 'Malaysia',
            'MX': 'Mexico',
            'NL': 'Netherlands',
            'NG': 'Nigeria',
            'PK': 'Pakistan',
            'PE': 'Peru',
            'RU': 'Russia',
            'SA': 'Saudi Arabia',
            'ZA': 'South Africa',
            'ES': 'Spain',
            'TR': 'Turkey',
            'AE': 'United Arab Emirates',
            'GB': 'United Kingdom',
            'US': 'United States',
            'NA': 'North America',
            'RA': 'Region A',
            'AP': 'Asia Pacific',
            'CE': 'Central Europe',
            'LA': 'Latin America',
            'ME': 'Middle East',
            'WE': 'Western Europe',
            'OTHERS': 'Others'
        };
        return countryMap[countryCode] || countryCode;
    };

    const userInformation = useRef({
        name: '',
        businessname: '',
        email: '',
        mobilenumber: '',
        address: '',
        city: '',
        districtname: '',
        state: '',
        pincode: '',
        token: '',
        country: 'IN',
    });

    useEffect(()=>{
      setloder(true);
      const myHeaders = new Headers();
      const access_token = getToken();
      myHeaders.append("Authorization", `Bearer ${access_token}`);

    const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow"
    };

     fetch(`${domain()}/my-account`, requestOptions)
        .then((response) => response.json())
        .then((result) => {
          setloder(false);
          if(result.status){
            // Ensure all fields are properly handled with null/undefined values
            userInformation.current.name = result.data.name || '';
            userInformation.current.businessname = result.data.business_name || '';
            userInformation.current.email = result.data.email || '';
            userInformation.current.mobilenumber = result.data.mobile_no || '';
            userInformation.current.address = result.data.address || '';
            userInformation.current.city = result.data.city || '';
            userInformation.current.districtname = result.data.district || '';
            userInformation.current.state = result.data.state || '';
            userInformation.current.pincode = result.data.pincode || '';
            userInformation.current.token = result.data.api_token || '';
            userInformation.current.country = result.data.country || 'IN';
            
            // Update form values with the fetched data
            setFieldValue('name', userInformation.current.name);
            setFieldValue('businessname', userInformation.current.businessname);
            setFieldValue('email', userInformation.current.email);
            setFieldValue('mobilenumber', userInformation.current.mobilenumber);
            setFieldValue('address', userInformation.current.address);
            setFieldValue('city', userInformation.current.city);
            setFieldValue('districtname', userInformation.current.districtname);
            setFieldValue('state', userInformation.current.state);
            setFieldValue('pincode', userInformation.current.pincode);
            setFieldValue('token', userInformation.current.token);
            setFieldValue('country', userInformation.current.country);
            
            // Debug: Log the values being set
            console.log('Setting field values:', {
              name: userInformation.current.name,
              businessname: userInformation.current.businessname,
              email: userInformation.current.email,
              mobilenumber: userInformation.current.mobilenumber,
              address: userInformation.current.address,
              city: userInformation.current.city,
              districtname: userInformation.current.districtname,
              state: userInformation.current.state,
              pincode: userInformation.current.pincode,
              token: userInformation.current.token,
              country: userInformation.current.country,
            });
            
            setDataLoaded(true);
            SuccessToastContainer(result.message);
          }else{
            ErrorToastContainer(result.message);
          }          
        })
        .catch((error) => {
          setloder(false);
          ErrorToastContainer('Internal Server Error');
      });
    },[]);
    
    const initialValues = {
        name: userInformation.current.name,
        businessname: userInformation.current.businessname,
        email: userInformation.current.email,
        mobilenumber: userInformation.current.mobilenumber,
        address: userInformation.current.address,
        city: userInformation.current.city,
        districtname: userInformation.current.districtname,
        state: userInformation.current.state,
        pincode: userInformation.current.pincode,
        token: userInformation.current.token,
        country: userInformation.current.country,
    }

      const RegisterSchema = Yup.object({
        name: Yup.string().required("Name is required").min(5, "Name must be at least 2 characters"),
        businessname: Yup.string().required("Business name is required").min(2, "Business name must be at least 2 characters"),
        email: Yup.string().email("Invalid email format").required("Email is required"),
        mobilenumber: Yup.string().required("Mobile number is required"),
        address: Yup.string().required("Address is required").min(5, "Address must be at least 5 characters"),
        city: Yup.string().required("City is required"),
        districtname: Yup.string().required("District name is required"),
        state: Yup.string().required("State is required"),
        pincode: Yup.string().matches(/^\d{6}$/, "Enter a valid 6-digit pincode").required("Pincode is required"),
        token: Yup.string().required("Click Generate Token"),
      });
    
  const {setFieldValue,values,errors,touched,handleBlur,handleChange,handleSubmit} = useFormik({
        initialValues: initialValues,
        validationSchema: RegisterSchema,
        enableReinitialize: true,
        onSubmit: (values) => {
          setloder(true);
          const myHeaders = new Headers();
          const access_token = getToken();
          myHeaders.append("Authorization", `Bearer ${access_token}`);
          const formdata = new FormData();
          formdata.append("name", values.name || '');
          formdata.append("business_name", values.businessname || '');
          formdata.append("email", values.email || '');
          formdata.append("mobile_no", values.mobilenumber || '');
          formdata.append("address", values.address || '');
          formdata.append("city", values.city || '');
          formdata.append("district", values.districtname || '');
          formdata.append("state", values.state || '');
          formdata.append("pincode", values.pincode || '');
          formdata.append("token", values.token || '');
          formdata.append("country", values.country || 'IN');
    
          const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: formdata,
          };
    
          fetch(`${domain()}/account-update`, requestOptions)
            .then((response) => response.json())
            .then((result) => {
              setloder(false);
              if(result.status){
                SuccessToastContainer(result.message);
              }else{
                ErrorToastContainer(result.message);
              }          
            })
            .catch((error) => {
              setloder(false);
              ErrorToastContainer('Internal Server Error');
          });
    
        },
    })

  // Handler for starting edit
  const handleEdit = (section) => {
    setEditingSection(section);
    // Ensure country is included in editValues
    const editData = { 
      ...values,
      country: values.country || 'IN' // Ensure country has a default value
    };
    console.log('Setting editValues:', editData); // Debug log
    setEditValues(editData);
  };
  // Handler for cancel
  const handleCancel = () => {
    setEditingSection(null);
    setEditValues({});
  };
  // Handler for save (calls update logic)
  const handleSave = async () => {
    try {
      setloder(true);
      const myHeaders = new Headers();
      const access_token = getToken();
      myHeaders.append("Authorization", `Bearer ${access_token}`);
      
      const formdata = new FormData();
      // Ensure all values are strings, not null/undefined
      const nameValue = (editValues.name || values.name || '').toString();
      const businessNameValue = (editValues.businessname || values.businessname || '').toString();
      const emailValue = (editValues.email || values.email || '').toString();
      const mobileValue = (editValues.mobilenumber || values.mobilenumber || '').toString();
      const addressValue = (editValues.address || values.address || '').toString();
      const cityValue = (editValues.city || values.city || '').toString();
      const districtValue = (editValues.districtname || values.districtname || '').toString();
      const stateValue = (editValues.state || values.state || '').toString();
      const pincodeValue = (editValues.pincode || values.pincode || '').toString();
      const tokenValue = (editValues.token || values.token || '').toString();
      const countryValue = (editValues.country || values.country || 'IN').toString();

      formdata.append("name", nameValue);
      formdata.append("business_name", businessNameValue);
      formdata.append("email", emailValue);
      formdata.append("mobile_no", mobileValue);
      formdata.append("address", addressValue);
      formdata.append("city", cityValue);
      formdata.append("district", districtValue);
      formdata.append("state", stateValue);
      formdata.append("pincode", pincodeValue);
      formdata.append("token", tokenValue);
      formdata.append("country", countryValue);

      // Debug: Log what values are being sent
      console.log('Sending values to API:', {
        name: nameValue,
        business_name: businessNameValue,
        email: emailValue,
        mobile_no: mobileValue,
        address: addressValue,
        city: cityValue,
        district: districtValue,
        state: stateValue,
        pincode: pincodeValue,
        token: tokenValue,
        country: countryValue,
      });
      console.log('Current editValues:', editValues);
      console.log('Current values:', values);

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
      };

      const response = await fetch(`${domain()}/account-update`, requestOptions);
      const result = await response.json();
      
      setloder(false);
      if(result.status){
        // Update the local values with the edited values
        Object.keys(editValues).forEach((key) => {
          values[key] = editValues[key];
        });
        setEditingSection(null);
        setEditValues({});
        SuccessToastContainer(result.message);
        // Refresh the data
        window.location.reload();
      } else {
        ErrorToastContainer(result.message);
      }
    } catch (error) {
      setloder(false);
      ErrorToastContainer('Internal Server Error');
    }
  };


    const GenerateToken = () =>{

        setloder(true);
        const myHeaders = new Headers();
        const access_token = getToken();
        myHeaders.append("Authorization", `Bearer ${access_token}`);

        const requestOptions = {
            method: "GET",
            headers: myHeaders,
          };
    
        fetch(`${domain()}/generate-token`, requestOptions)
        .then((response) => response.json())
        .then((result) => {
          setloder(false);
          if(result.status){
            setFieldValue('token',result.data);
            SuccessToastContainer(result.message);
          }else{
            ErrorToastContainer(result.message);
          }          
        })
        .catch((error) => {
          setloder(false);
          ErrorToastContainer('Internal Server Error');
      });
    }

  // Helper for avatar initials
  const getInitials = (name) => {
    if (!name) return 'U';
    const parts = name.split(' ');
    if (parts.length === 1) return parts[0][0].toUpperCase();
    return (parts[0][0] + parts[1][0]).toUpperCase();
  };
  // Settings page is always accessible, individual actions are controlled by specific permissions

  // Dummy location (replace with real if available)
  const location = (values.city || '') + (values.state ? ', ' + values.state : '');
  return (
    <div className="main-panel w-100 p-0" style={{minHeight: '100vh', background: '#f7f8fa'}}>
      <Preloader action={loder}/>
      <div className="container-fluid py-4 px-2 px-md-5" style={{maxWidth: 1200, margin: '0 auto'}}>
        {/* Profile Header */}
        <div className="profile-header-card card border-0 shadow-sm mb-4 p-4 d-flex flex-row align-items-center gap-4" style={{ borderRadius: '20px', border: '1px solid #e2e8f0', boxShadow: '0 4px 20px rgba(0, 0, 0, 0.05)' }}>
          <div className="profile-avatar" style={{width: 80, height: 80, borderRadius: '50%', background: 'linear-gradient(135deg, #075E54 0%, #128C7E 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 32, color: '#fff', fontWeight: 700}}>
            {getInitials(values.name)}
          </div>
          <div>
            <h3 className="mb-1" style={{fontWeight: 700}}>{values.name || 'User Name'}</h3>
            <div className="d-flex align-items-center text-muted mb-1" style={{fontSize: 15}}>{values.businessname || 'User Role'}</div>
            <div className="d-flex align-items-center text-muted" style={{fontSize: 15}}>
              <FontAwesomeIcon icon={faMapMarkerAlt} className="me-2"/>
              {location || 'Location'}
            </div>
            <div className="d-flex align-items-center mt-2">
              <a 
                href="https://documenter.getpostman.com/view/46662670/2sB34kEJy8" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-decoration-none d-flex align-items-center gap-2"
                style={{color: '#3b82f6', fontSize: 14, fontWeight: 500}}
              >
                <FontAwesomeIcon icon={faFile} style={{fontSize: 12}}/>
                View Documentation
              </a>
            </div>
          </div>
        </div>
        {/* Personal Information Card */}
        <div className="info-card card border-0 shadow-sm mb-4 p-4 position-relative" style={{ borderRadius: '20px', border: '1px solid #e2e8f0', boxShadow: '0 4px 20px rgba(0, 0, 0, 0.05)' }}>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h5 className="mb-0" style={{color: '#1e293b', fontWeight: 600}}>Personal Information</h5>
            {editingSection === 'personal' ? (
              <div>
                <button className="btn btn-success btn-sm me-2" style={{borderRadius: 8}} onClick={handleSave}>Save</button>
                <button className="btn btn-secondary btn-sm" style={{borderRadius: 8}} onClick={handleCancel}>Cancel</button>
              </div>
            ) : (
              <button className="btn btn-light btn-sm px-3 py-1 d-flex align-items-center gap-2" style={{borderRadius: 8, border: '1px solid #fbbf24', color: '#f59e42', fontWeight: 500}} onClick={() => handleEdit('personal')}>
                Edit <FontAwesomeIcon icon={faUserEdit}/>
              </button>
            )}
          </div>
          <div className="row g-4">
            {editingSection === 'personal' ? (
              <>
                <div className="col-12 col-md-4">
                  <div className="label">First Name</div>
                  <input className="form-control" value={editValues.name?.split(' ')[0] || ''} onChange={e => setEditValues({...editValues, name: e.target.value + ' ' + (editValues.name?.split(' ')[1] || '')})} />
                </div>
                <div className="col-12 col-md-4">
                  <div className="label">Last Name</div>
                  <input className="form-control" value={editValues.name?.split(' ')[1] || ''} onChange={e => setEditValues({...editValues, name: (editValues.name?.split(' ')[0] || '') + ' ' + e.target.value})} />
                </div>
                <div className="col-12 col-md-4">
                  <div className="label">Email Address</div>
                  <input className="form-control" value={editValues.email || ''} onChange={e => setEditValues({...editValues, email: e.target.value})} />
                </div>
                <div className="col-12 col-md-4">
                  <div className="label">Phone Number</div>
                  <input className="form-control" value={editValues.mobilenumber || ''} onChange={e => setEditValues({...editValues, mobilenumber: e.target.value})} />
                </div>
                <div className="col-12 col-md-4">
                  <div className="label">Business Name</div>
                  <input className="form-control" value={editValues.businessname || ''} onChange={e => setEditValues({...editValues, businessname: e.target.value})} />
                </div>
              </>
            ) : (
              <>
                <div className="col-12 col-md-4">
                  <div className="label">First Name</div>
                  <div className="value">{values.name?.split(' ')[0] || '-'}</div>
                </div>
                <div className="col-12 col-md-4">
                  <div className="label">Last Name</div>
                  <div className="value">{values.name?.split(' ')[1] || '-'}</div>
                </div>
                <div className="col-12 col-md-4">
                  <div className="label">Email Address</div>
                  <div className="value">{values.email || '-'}</div>
                </div>
                <div className="col-12 col-md-4">
                  <div className="label">Phone Number</div>
                  <div className="value">{values.mobilenumber || '-'}</div>
                </div>
                <div className="col-12 col-md-4">
                  <div className="label">Business Name</div>
                  <div className="value">{values.businessname || '-'}</div>
                </div>
              </>
            )}
          </div>
        </div>
        {/* Address Card */}
        <div className="info-card card border-0 shadow-sm mb-4 p-4 position-relative" style={{ borderRadius: '20px', border: '1px solid #e2e8f0', boxShadow: '0 4px 20px rgba(0, 0, 0, 0.05)' }}>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h5 className="mb-0" style={{color: '#1e293b', fontWeight: 600}}>Address</h5>
            {editingSection === 'address' ? (
              <div>
                <button className="btn btn-success btn-sm me-2" style={{borderRadius: 8}} onClick={handleSave}>Save</button>
                <button className="btn btn-secondary btn-sm" style={{borderRadius: 8}} onClick={handleCancel}>Cancel</button>
              </div>
            ) : (
              <button className="btn btn-light btn-sm px-3 py-1 d-flex align-items-center gap-2" style={{borderRadius: 8, border: '1px solid #fbbf24', color: '#f59e42', fontWeight: 500}} onClick={() => handleEdit('address')}>
                Edit <FontAwesomeIcon icon={faUserEdit}/>
              </button>
            )}
          </div>
          <div className="row g-4">
            {editingSection === 'address' ? (
              <>
                <div className="col-12 col-md-6">
                  <div className="label">Address</div>
                  <input className="form-control" value={editValues.address || ''} onChange={e => setEditValues({...editValues, address: e.target.value})} />
                </div>
                <div className="col-12 col-md-4">
                  <div className="label">Country</div>
                  <select 
                    className="form-control" 
                    value={editValues.country || 'IN'} 
                    onChange={e => setEditValues({...editValues, country: e.target.value})}
                  >
                    <option value="">Select Country</option>
                    <option value="AR">Argentina</option>
                    <option value="BR">Brazil</option>
                    <option value="CL">Chile</option>
                    <option value="CO">Colombia</option>
                    <option value="EG">Egypt</option>
                    <option value="FR">France</option>
                    <option value="DE">Germany</option>
                    <option value="IN">India</option>
                    <option value="ID">Indonesia</option>
                    <option value="IL">Israel</option>
                    <option value="IT">Italy</option>
                    <option value="MY">Malaysia</option>
                    <option value="MX">Mexico</option>
                    <option value="NL">Netherlands</option>
                    <option value="NG">Nigeria</option>
                    <option value="PK">Pakistan</option>
                    <option value="PE">Peru</option>
                    <option value="RU">Russia</option>
                    <option value="SA">Saudi Arabia</option>
                    <option value="ZA">South Africa</option>
                    <option value="ES">Spain</option>
                    <option value="TR">Turkey</option>
                    <option value="AE">United Arab Emirates</option>
                    <option value="GB">United Kingdom</option>
                    <option value="US">United States</option>
                    <option value="NA">North America</option>
                    <option value="RA">Region A</option>
                    <option value="AP">Asia Pacific</option>
                    <option value="CE">Central Europe</option>
                    <option value="LA">Latin America</option>
                    <option value="ME">Middle East</option>
                    <option value="WE">Western Europe</option>
                    <option value="OTHERS">Others</option>
                  </select>
                </div>
                <div className="col-12 col-md-4">
                  <div className="label">City</div>
                  <input className="form-control" value={editValues.city || ''} onChange={e => setEditValues({...editValues, city: e.target.value})} />
                </div>
                <div className="col-12 col-md-4">
                  <div className="label">District</div>
                  <input className="form-control" value={editValues.districtname || ''} onChange={e => setEditValues({...editValues, districtname: e.target.value})} />
                </div>
                <div className="col-12 col-md-4">
                  <div className="label">State</div>
                  <select 
                    className="form-control" 
                    value={editValues.state || ''} 
                    onChange={e => setEditValues({...editValues, state: e.target.value})}
                  >
                    <option value="">Select State</option>
                    <option value="AN">Andaman and Nicobar Islands (AN)</option>
                    <option value="AP">Andhra Pradesh (AP)</option>
                    <option value="AR">Arunachal Pradesh (AR)</option>
                    <option value="AS">Assam (AS)</option>
                    <option value="BR">Bihar (BR)</option>
                    <option value="CH">Chandigarh (CH)</option>
                    <option value="CG">Chhattisgarh (CG)</option>
                    <option value="DN">Dadra and Nagar Haveli (DN)</option>
                    <option value="DD">Daman and Diu (DD)</option>
                    <option value="DL">Delhi (DL)</option>
                    <option value="GA">Goa (GA)</option>
                    <option value="GJ">Gujarat (GJ)</option>
                    <option value="HR">Haryana (HR)</option>
                    <option value="HP">Himachal Pradesh (HP)</option>
                    <option value="JK">Jammu and Kashmir (JK)</option>
                    <option value="JH">Jharkhand (JH)</option>
                    <option value="KA">Karnataka (KA)</option>
                    <option value="KL">Kerala (KL)</option>
                    <option value="LD">Lakshadweep (LD)</option>
                    <option value="MP">Madhya Pradesh (MP)</option>
                    <option value="MH">Maharashtra (MH)</option>
                    <option value="MN">Manipur (MN)</option>
                    <option value="ML">Meghalaya (ML)</option>
                    <option value="MZ">Mizoram (MZ)</option>
                    <option value="NL">Nagaland (NL)</option>
                    <option value="OD">Odisha (OD)</option>
                    <option value="PY">Puducherry (PY)</option>
                    <option value="PB">Punjab (PB)</option>
                    <option value="RJ">Rajasthan (RJ)</option>
                    <option value="SK">Sikkim (SK)</option>
                    <option value="TN">Tamil Nadu (TN)</option>
                    <option value="TS">Telangana (TS)</option>
                    <option value="TR">Tripura (TR)</option>
                    <option value="UP">Uttar Pradesh (UP)</option>
                    <option value="UK">Uttarakhand (UK)</option>
                    <option value="WB">West Bengal (WB)</option>
                    <option value="OT">Others</option>
                  </select>
                </div>
                <div className="col-12 col-md-4">
                  <div className="label">Postal Code</div>
                  <input className="form-control" value={editValues.pincode || ''} onChange={e => setEditValues({...editValues, pincode: e.target.value})} />
                </div>
              </>
            ) : (
              <>
                <div className="col-12 col-md-4">
                  <div className="label">Address</div>
                  <div className="value">{values.address || '-'}</div>
                </div>
                <div className="col-12 col-md-4">
                  <div className="label">Country</div>
                  <div className="value">{getCountryName(values.country) || 'India'}</div>
                </div>
                <div className="col-12 col-md-4">
                  <div className="label">City</div>
                  <div className="value">{values.city || '-'}</div>
                </div>
                <div className="col-12 col-md-4">
                  <div className="label">District</div>
                  <div className="value">{values.districtname || '-'}</div>
                </div>
                <div className="col-12 col-md-4">
                  <div className="label">State</div>
                  <div className="value">{values.state || '-'}</div>
                </div>
                <div className="col-12 col-md-4">
                  <div className="label">Postal Code</div>
                  <div className="value">{values.pincode || '-'}</div>
                </div>
              </>
            )}
          </div>
        </div>
        {/* API Token Card */}
        <div className="info-card card border-0 shadow-sm mb-4 p-4 position-relative" style={{
          borderRadius: '20px',
          border: '1px solid #e2e8f0',
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.05)',
          filter: userServices.api !== 1 ? 'blur(3px)' : 'none',
          pointerEvents: userServices.api !== 1 ? 'none' : 'auto',
          opacity: userServices.api !== 1 ? 0.6 : 1,
          position: 'relative'
        }}>
          {userServices.api !== 1 && (
            <div style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              zIndex: 10,
              background: 'rgba(255, 255, 255, 0.95)',
              padding: '20px',
              borderRadius: '10px',
              textAlign: 'center',
              boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
              border: '2px solid #ff6b6b'
            }}>
              <div style={{color: '#ff6b6b', fontSize: '24px', marginBottom: '10px'}}>🔒</div>
              <h6 style={{color: '#333', marginBottom: '8px'}}>API Service Not Active</h6>
              <p style={{color: '#666', fontSize: '14px', margin: 0}}>Please activate the API service to access this feature</p>
            </div>
          )}
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h5 className="mb-0" style={{color: '#1e293b', fontWeight: 600}}>API Token</h5>
            <button 
              className="btn btn-light btn-sm px-3 py-1 d-flex align-items-center gap-2" 
              style={{borderRadius: 8, border: '1px solid #3b82f6', color: '#2563eb', fontWeight: 500}} 
              onClick={GenerateToken}
              disabled={userServices.api !== 1}
            >
              Generate
            </button>
          </div>
          <div className="row g-4 align-items-center">
            <div className="col-12 col-md-8">
              <div className="label">Current Token</div>
              <div className="value" style={{letterSpacing: '0.5px', userSelect: 'all'}}>
                {values.token ? <span style={{fontFamily: 'monospace'}}>{values.token}</span> : <span className="text-muted">No token generated</span>}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Myaccount
